import {Component, OnInit} from '@angular/core';
import {NavigationEnd, NavigationStart, Router} from '@angular/router';
import {Location, PopStateEvent} from '@angular/common';
import {HttpClient} from '@angular/common/http';
import {AuthenticationService} from '../../services/authentication/authentication.service';
import {faChild, faDna, faInfo, faNewspaper, faPhone, faQuestion} from '@fortawesome/free-solid-svg-icons';
import {djangourl} from '../../../assets/urls';
import {faBookOpen} from '@fortawesome/free-solid-svg-icons/faBookOpen';

@Component({
  selector: 'app-landing-navbar',
  templateUrl: './landing-navbar.component.html',
  styleUrls: ['./landing-navbar.component.scss']
})
export class LandingNavbarComponent implements OnInit {
  dna = faDna;
  info = faInfo;
  blog = faNewspaper;
  child = faChild;
  phone = faPhone;
  book = faBookOpen;
  faq = faQuestion;
  public isCollapsed = true;
  private lastPoppedUrl: string;
  private yScrollStack: number[] = [];
  private user: any;
  apiUrl = 'api/user/';
  name = '';


  constructor(public location: Location, private router: Router, private http: HttpClient, private authenticationService: AuthenticationService) {
  }

  ngOnInit() {


    const currentUser = this.authenticationService.currentUserValue;
    if (currentUser) {
      this.name = currentUser.first_name + ' ' + currentUser.last_name;
    }

    this.router.events.subscribe((event) => {
      this.isCollapsed = true;
      if (event instanceof NavigationStart) {
        if (event.url !== this.lastPoppedUrl) {
          this.yScrollStack.push(window.scrollY);
        }
      } else if (event instanceof NavigationEnd) {
        if (event.url === this.lastPoppedUrl) {
          this.lastPoppedUrl = undefined;
          window.scrollTo(0, this.yScrollStack.pop());
        } else {
          window.scrollTo(0, 0);
        }
      }
    });
    this.location.subscribe((ev: PopStateEvent) => {
      this.lastPoppedUrl = ev.url;
    });
  }

  isHome() {
    const titlee = this.location.prepareExternalUrl(this.location.path());

    if (titlee === '#/home') {
      return true;
    } else {
      return false;
    }
  }

  isDocumentation() {
    const titlee = this.location.prepareExternalUrl(this.location.path());
    if (titlee === '#/documentation') {
      return true;
    } else {
      return false;
    }
  }

  getbg() {
    let titlee = this.location.prepareExternalUrl(this.location.path());
    if (titlee.charAt(0) === '#') {
      titlee = titlee.slice(1);
    }
    switch (titlee) {
      default:
      case '/home':
        return 'bg-gradient-indigo';
      case '/contact-us':
        return 'bg-gradient-default';
      case '/about-us':
        return 'bg-gradient-red';
    }
  }

}
